import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { config } from '../../shared/config'
import { map } from 'rxjs/operators'
import { SettingsModel } from '../models/settings.model'
import { BaseHttpService } from './base-http.service'
import { StorageService } from '../storage/storage.service'

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  public getSettings(): Observable<SettingsModel[]> {
    return this.get(config.generateApiUrl('Settings', null, null, '2.2')).pipe(map((res: any) => res.data as SettingsModel[]))
  }

  getTag(tagName: string): Observable<any> {
    return this.get(config.generateApiUrl(`Settings/${tagName}`, null, null, '2.2')).pipe(
      map(resp => resp['data'] as SettingsModel),
    )
  }

  editTag(tagName: string, tagValue: any): Observable<SettingsModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }
    return this._http
      .put(config.generateApiUrl(`settings/${tagName}`, null, null, '2.2'), JSON.stringify(tagValue), httpOptions)
      .pipe(map(resp => resp['data'] as SettingsModel))
  }

  deleteTag(tagName: string): Observable<SettingsModel> {
    return this._http
      .delete(config.generateApiUrl(`settings/unset/${tagName}`, null, null, '2.2'))
      .pipe(map(resp => resp['data']))
  }
}
